import { api } from '@/lib/api'

export type StakerStats = {
	totalStaked: string
	totalPending: string
	totalClaimable: string
	totalRewarded: string
	validators: Array<{
		validator: string
		owner: string
		name: string | null
		logoUrl: string | null
		type: string
		status: string
		totalDelegated: string
		apr: number | null
		commission: number
		isStakerValidatorOwner: boolean
		disabled: boolean | null
		stakeInfo: {
			staked: string
			pending: string
			claimable: string
			canClaim: boolean
			canUndelegate: boolean
		}
	}>
}

export async function getStakerStats(prefixUrl: string, staker: string) {
	const data = await api
		.get(`stats/staker/${staker}`, {
			prefixUrl
		})
		.json<StakerStats>()

	return data
}
